import React, { useState } from 'react';
import { ThemeSetup } from '../../../../themes/ThemeSetup';
import './MoveToBinSubMenu.css';
import { debounce } from 'lodash';
import SearchOption from '../../../form/dropdown-search/SearchOption';
import SearchUtil from '../../../../util/SearchUtil';
import CollectionUtil from '../../../../queries/lightbox/CollectionUtil';
import { toast } from '../../../../store/StoreUtil';
import { treeEmitter } from '../../../../tabs/collections/CollectionsTree';
import t from '../../../../i18n/I18n';
const MoveToBinSubMenu = ({ collection, onItemSelect, closeContextMenu }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);

  const debouncedSearchInputChange = debounce((query) => {
    if (query === '') {
      // If the search input is empty, clear the filtered options
      setFilteredOptions([]);
    } else {
      // Filter the options based on the search query
      const autoSearch = SearchUtil.searchCollectionAutoComplete(query, true, false);
      autoSearch.then((resp) => {
        setFilteredOptions(getOptionsFromCollections(resp.getMatchedCollection()));
      });
    }
  }, 300);

  const handleSearchInputChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    debouncedSearchInputChange(query); // Call the debounced function
  };

  const handleOnItemSelect = async (item) => {
    if (collection) {
      await CollectionUtil.editCollectionParent(collection, item.getId())
        .then(async success => {
          if (success) {
            let collectionTreeIdsToRefresh = [item.getId()];
            if (collection.getParentId() > 0)
              collectionTreeIdsToRefresh = [...collectionTreeIdsToRefresh, collection.getParentId()];
            else
                collectionTreeIdsToRefresh = [...collectionTreeIdsToRefresh, CollectionUtil.ROOT_COLLECTION_ID];
            //Todo: Move these two in the refresh after doing any operation.
            await CollectionUtil.loadCollectionsInView(collection.getParentId());
            toast(t('MOVED_SUCCESFULLY'));
            treeEmitter.emit('refreshNodes', collectionTreeIdsToRefresh);
          }
          else {
            toast(t('UNKNOWN_ERROR'));
          }
        })
        .catch(error => {
          console.log(error);
          if (error.errorDetails && error.errorDetails.length > 0) toast(error.errorDetails);
          else toast(error.statusText);
        });
    }

    if (onItemSelect)
      onItemSelect(item);
    if (closeContextMenu)
      closeContextMenu();
  };

  const getOptionsFromCollections = (collectionOptions) => {
    let options: Array<SearchOption> = [];
    if (collectionOptions && collectionOptions.length) {
      for (const collectionOption of collectionOptions) {
        let searchOption = new SearchOption()
          .setId(collectionOption.getCollectionId())
          .setName(collectionOption.getName());
        options.push(searchOption);
      }
    }
    return options;
  };

  return (
    <div>
      <div className="moveToBinInpWrapper">
        <input
          className="moveToBinInp"
          type="text"
          placeholder="Search Bins"
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <img src="images/icons_search.svg" alt="Search" />
      </div>

      <div className="moveToBinOptionsWrapper">
        {filteredOptions.map((option, index) => (
          <div className="moveToBinOption" key={index} onClick={() => handleOnItemSelect(option)}>
            <img src="images/icons_bin.svg" alt="" />
            <span>{option.getName()}</span>
          </div>
        ))}
        {/* Add more list items as needed */}
      </div>
    </div>
  );
};

export default MoveToBinSubMenu;
